import React, { useRef, useState } from 'react';
import { Text, View, Image, TouchableOpacity, StyleSheet } from 'react-native';
import i18n from 'i18n-js';
import { useHover } from 'react-native-web-hooks';

import { scale } from '@components/frame';
import TouchableElement from '@components/common/touchableElement';
import RadioButton from '@components/common/radioButton';
import { font } from '@styles/fonts';
import ColorsWrapper from '@styles/colors';
import { isPhone } from '@helpers';

const Button = ({ index, b, C, btnBorder, bntWidth, rounding, getFont, getColor, hide }) => {
  const ref = useRef(null);

  const hovered = useHover(ref);
  const [pressed, setPressed] = useState(false);

  return (
    <View
      style={[
        {
          width: bntWidth,
        },
        index !== 0 && btnBorder,
      ]}
    >
      <TouchableOpacity
        ref={ref}
        onPress={() => {
          hide();
          if (b.onPress) {
            b.onPress();
          }
        }}
        style={[
          rounding(index),
          hovered && {
            backgroundColor: C('Button/Light/Only Text hover'),
          },
          pressed && {
            backgroundColor: C('Button/Light/Only Text pressed'),
          },

          {
            width: '100%',
            paddingTop: scale(9),
            paddingBottom: scale(11),
            justifyContent: 'center',
            alignItems: 'center',
            alignContent: 'center',
          },
        ]}
        onPressIn={() => {
          setPressed(true);
        }}
        onPressOut={() => {
          setPressed(false);
        }}
        activeOpacity={1}
      >
        <Text style={[getFont(b.style), { color: C(getColor(b.style)) }]}>{i18n.t(b.text)}</Text>
      </TouchableOpacity>
    </View>
  );
};

const SelectFavorite = (props) => {
  const { current, selected, selectedKey, C, hide, submitChange } = props;
  const [selectedImage, setSelectedImage] = useState('new');

  const getFont = (style) => {
    switch (style) {
      case 'secondary':
        return font['Body'];
      case 'primary':
        return font['Headline'];
      case 'danger':
        return font['Body'];
      default:
        return font['Body'];
    }
  };
  const getColor = (style) => {
    switch (style) {
      case 'danger':
        return 'Label/Light/Error';
      default:
        return 'Link/Light/Special';
    }
  };

  const conf = [
    { text: i18n.t('Cancel'), onPress: () => {} },
    {
      text: i18n.t('OK'),
      onPress: () => {
        if (selectedImage === 'new') {
          submitChange();
        }
      },
      style: 'primary',
    },
  ];

  const bntWidth = `${100 / conf.length}%`;

  const btnBorder = {
    borderLeftColor: C('Hairline/Light/No trans'),
    borderLeftWidth: StyleSheet.hairlineWidth,
  };
  const rounding = (index) => {
    if (index === 0) {
      return {
        borderBottomLeftRadius: scale(11),
      };
    }
    if (index === conf.length - 1) {
      return {
        borderBottomRightRadius: scale(11),
      };
    }
    return {};
  };

  return (
    <View>
      <View style={{ paddingHorizontal: scale(16) }}>
        <View
          style={{
            marginTop: scale(16),
            width: '100%',
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Text style={[font.Headline, { color: C('Label/Light/Primary'), textAlign: 'center' }]}>
            {i18n.t('Select {{key}} Picture', { key: selectedKey })}
          </Text>
          <Text style={[font['Caption 1'], { color: C('Label/Light/Primary'), marginTop: scale(4), textAlign: 'center' }]}>
            {i18n.t('Another {{key}} picture already exists.', { key: selectedKey })}
          </Text>
          <Text style={[font['Caption 1'], { color: C('Label/Light/Primary'), textAlign: 'center' }]}>
            {i18n.t('Would you like to keep the existing {{key}} picture or select the new?', { key: selectedKey })}
          </Text>
        </View>
        <View style={{ marginTop: scale(13), marginBottom: scale(23), flexDirection: 'row' }}>
          <TouchableElement onPress={() => setSelectedImage('existing')}>
            {({ boxStyle }) => (
              <View style={(boxStyle, [{ flex: 1, paddingRight: scale(8), alignItems: 'center' }])}>
                <View style={[boxStyle, { width: '100%', alignItems: 'center' }]}>
                  <Image
                    style={{ width: '100%', height: scale(isPhone ? 84 : 144) }}
                    source={{
                      uri: current.base64 || current.url,
                    }}
                    resizeMode="contain"
                  />
                </View>
                <View style={{ alignItems: 'center' }}>
                  <Text style={[font['Subhead 1'], { color: C('Label/Light/Primary'), marginTop: scale(5) }]}>{i18n.t('Existing')}</Text>
                  <View style={{ marginTop: scale(3) }}>
                    <RadioButton {...{ isSelected: selectedImage === 'existing', onSelect: () => setSelectedImage('existing') }} />
                  </View>
                </View>
              </View>
            )}
          </TouchableElement>
          <TouchableElement onPress={() => setSelectedImage('new')}>
            {({ boxStyle }) => (
              <View style={(boxStyle, [{ flex: 1, paddingLeft: scale(8), alignItems: 'center' }])}>
                <View style={[boxStyle, { width: '100%', alignItems: 'center' }]}>
                  <Image
                    style={{ width: '100%', height: scale(isPhone ? 84 : 144) }}
                    source={{
                      uri: selected.base64 || selected.url,
                    }}
                    resizeMode="contain"
                  />
                </View>
                <View style={{ alignItems: 'center' }}>
                  <Text style={[font['Subhead 1'], { color: C('Label/Light/Primary'), marginTop: scale(5) }]}>{i18n.t('New')}</Text>
                  <View style={{ marginTop: scale(3) }}>
                    <RadioButton {...{ isSelected: selectedImage === 'new', onSelect: () => setSelectedImage('new') }} />
                  </View>
                </View>
              </View>
            )}
          </TouchableElement>
        </View>
      </View>
      <View
        style={{
          flexDirection: 'row',
          borderTopColor: C('Hairline/Light/No trans'),
          borderTopWidth: StyleSheet.hairlineWidth,
        }}
      >
        {conf.map((b, index) => (
          <Button key={`${b.text}-${index}`} {...{ b, index, C, btnBorder, bntWidth, rounding, getFont, getColor, hide }} />
        ))}
      </View>
    </View>
  );
};

export default ColorsWrapper(SelectFavorite);
